<template>
    <v-card width="100%" class="ma-0 pa-0" outlined>
        <v-card-actions class="ma-0 pa-0">
            <v-data-table
                    style="width: 100%;"
                    fixed-header
                    :items="configs"
                    :headers="headers"
                    hide-default-footer
                    disable-pagination>

                <template v-slot:item.group="{ item }">
                    <v-card-text class="orange--text subtitle-2 ma-0 pa-0">{{ item.group }}</v-card-text>
                </template>

                <template v-slot:item.tag="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                   outlined
                                   v-bind="attrs"
                                   v-on="on"

                                   small
                                   class="green--text subtitle-2">
                                {{getTagText(item.tag)}}
                            </v-btn>
                        </template>
                        <span>{{item.tag }}</span>
                    </v-tooltip>
                </template>

                <template v-slot:item.meta.uid="{ item }">
                    <v-card-text class="blue--text subtitle-2 ma-0 pa-0">{{ getOwner(item) }}</v-card-text>
                </template>

                <template v-slot:item.meta.updated="{ item }">
                    {{ getUpdated(item) | formatDate }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom max-width="50%">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon
                                   color="orange"
                                   v-bind="attrs"
                                   v-on="on"
                                   class="ma-0 pa-0">
                                <v-icon size="22">mdi-information</v-icon>
                            </v-btn>
                        </template>
                        <span>{{item.info != undefined && item.info.length != 0 ? item.info : "no info"}}</span>
                    </v-tooltip>

<!--                    <v-tooltip bottom max-width="50%">-->
<!--                        <template v-slot:activator="{ on, attrs }">-->
<!--                            <v-btn icon-->
<!--                                   color="red"-->
<!--                                   v-bind="attrs"-->
<!--                                   v-on="on"-->
<!--                                   @click="onPressDelete(item)"-->
<!--                                   class="ma-0 pa-0">-->
<!--                                <v-icon size="22">mdi-delete</v-icon>-->
<!--                            </v-btn>-->
<!--                        </template>-->
<!--                        <span>Delete</span>-->
<!--                    </v-tooltip>-->

                </template>
            </v-data-table>
        </v-card-actions>
    </v-card>
</template>

<script>

import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import {ConfigBackendUtils} from "@/modules/mconfigs/database/ConfigBackendUtils";
import {ConfigModel} from "@/modules/mconfigs/models/ConfigModel";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";

export default {
    name: "c-master-table",
    data: () => ({
        headers: [
            {text: 'Group', sortable: true, value: 'group', class: "white blue--text", color: "red"},
            {text: 'Tag', sortable: true, value: 'tag', class: "white blue--text", color: "red"},
            {text: 'Id', sortable: true, value: 'uid', class: "white blue--text"},
            {text: 'Owner', sortable: true, value: 'meta.uid', class: "white blue--text"},
            {text: 'Updated', sortable: true, value: 'meta.updated', class: "white blue--text"},
            {text: 'Actions', sortable: false, value: 'actions', width: '160px', class: "white blue--text"}
        ],
        loading: null
    }),
    methods: {
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        // ifCanEditConfigTag(){
        //     return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_PRE_EDIT_TAG.id)
        // },
        // ifCanCopyConfigToMyConfigs(){
        //     return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_PRE_COPY_TO_MY.id)
        // },
        // ifCanDeployConfigToStorage(){
        //     return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_PRE_DEPLOY_TO_STORAGE.id)
        // },
        // ifCanSetInfo(){
        //     return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_PRE_SET_INFO.id)
        // },
        getUserName(user){
            return PermissionsStoreUtils.getUserName(user.uid)
        },
        // onPressInfo(config){
        //     if (!this.ifCanSetInfo()){
        //         this.$notify({title: 'No permissions', text: "", type: "error"});
        //         return
        //     }
        //     this.$emit('show-configs-popup-edit-info', config)
        // },
        onPressDelete(config){
            //ConfigStoreUtils.deleteMasterConfig(config.uid)
        },
        getTagText(tag){
            let text = tag
            if (text.length > 25){
                text = text.substring(0,30) + "..."
            }
            return text// + text.length
        },
        // onPressEditTag(config) {
        //     this.$emit('show-c-edit-tag-popup', config)
        // },
        // onPressDeployWithMerge(config) {
        //     this.$emit('show-c-p-r-deploy-with-merge-popup', config)
        // },
        // onPressDeploy(config) {
        //     this.$confirm("Are you sure?").then(() => {
        //         this.loading = config.uid
        //         ConfigStoreUtils.getConfigData("configs_data/" + config.uid)
        //             .then((data) => {
        //                 ConfigBackendUtils.deployConfig({group:config.group, owner:config.meta.uid, tag:config.tag, content: data}, config.uid)
        //                     .then(() => {
        //                         this.loading = null
        //                         this.$notify({title: 'Config successfully deployed!', text: "", type: "succes"});
        //                     })
        //                     .catch((error) => {
        //                         this.loading = null
        //                         this.$notify({title: 'Config deploy failed!', text: error, type: "error"});
        //                     })
        //             }).catch((error) => {
        //             this.$notify({title: 'Failed to get config data to copy!', text: error, type: "error"});
        //         })
        //     })
        // },
        // onPressCopy(config) {
        //     let configCopy = new ConfigModel(config.group + "_release_copy")
        //     ConfigStoreUtils.getConfigData("configs_data/" + config.uid)
        //         .then((data) => {
        //             ConfigStoreUtils.pushConfig(configCopy, data).then(() => {
        //                 this.$notify({title: 'Config successfully copied!', text: "", type: "succes"});
        //             }).catch((error) => {
        //                 this.$notify({title: 'Config copied failed!', text: error, type: "error"});
        //             })
        //         }).catch((error) => {
        //         this.$notify({title: 'Failed to get config data to copy!', text: error, type: "error"});
        //     })
        // },
        getOwner(config) {
            if (config.meta == null) {
                return "no metadata"
            }
            return this.getUserName(config.meta)
        },
        getUpdated(config) {
            if (config.meta == null) {
                return "no metadata"
            }
            return config.meta.updated
        },
    },
    computed: {
        configs() {
            return ConfigStoreUtils.getMasterConfigs();
        }
    }
}
</script>

<style scoped>
</style>